<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Result Analysis'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="8"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Result Analysis</div>
          <tab-view>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2020-21</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year20" class="w-9/12"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2019-20</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year19" class="w-9/12"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2018-19</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year18" class="w-9/12"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2017-18</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year17" class="w-9/12"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2016-17</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year16" class="w-9/12"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2015-16</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year15" class="w-9/12"/>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>

import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Chart from 'primevue/chart';

export default {
  name: "ResultAnalysis",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    Chart
  },
  data() {
    return {
      year20: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2020-21',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [80, 76, 4, 23, 52, 1, 0, 0],
            maxBarThickness: 50
          }
        ],

      },
      year19: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2019-20',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [70, 60, 10, 34, 25, 1, 0, 0],
            maxBarThickness: 50
          }
        ],
      },
      year18: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2018-19',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [70, 60, 10, 34, 25, 1, 0, 0],
            maxBarThickness: 50
          }
        ],
      },
      year17: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2017-18',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [70, 60, 10, 34, 25, 1, 0, 0],
            maxBarThickness: 50
          }
        ],
      },
      year16: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2016-17',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [70, 60, 10, 34, 25, 1, 0, 0],
            maxBarThickness: 50
          }
        ],
      },
      year15: {
        labels: ['Appeared', 'Passed', 'Failed', 'Distinction', 'First Class', 'Higher Second Class', 'Second Class', 'Pass'],
        datasets: [
          {
            label: 'Result Analysis of A. Y. 2015-16',
            backgroundColor: ['#33ccff', '#ff3399', '#ff0000', '#008000', '#ff9933', '#ff4da6', '#ff7c43', '#ffa600'],
            data: [36, 28, 8, 11, 17, 0, 0, 0],
            maxBarThickness: 50
          }
        ],
      }
    }
  },

}
</script>
<style lang="scss" scoped/>